export const HST_RATE = 0.13;

const num = (v) => (v === "" || v == null ? 0 : Number(v));

export function computeTotals(d) {
  let taxable =
    num(d.sale_price) + num(d.warranty_price) + num(d.admin_fee) + num(d.safety_cert_fee);
  const otherFees = d.other_fees || [];
  taxable += otherFees
    .filter((f) => f.taxable !== false)
    .reduce((s, f) => s + num(f.amount), 0);
  const nonTaxableFees = otherFees
    .filter((f) => f.taxable === false)
    .reduce((s, f) => s + num(f.amount), 0);
  const taxableNet = Math.max(taxable - num(d.trade_in_value), 0);
  const taxExempt = Boolean(d.tax_exempt);
  const hst = taxExempt ? 0 : +(taxableNet * HST_RATE).toFixed(2);
  const total = +(taxableNet + hst + nonTaxableFees + num(d.licensing_fee) + num(d.lien_amount)).toFixed(2);
  const balance = +(total - num(d.deposit)).toFixed(2);
  return {
    taxable_subtotal: +taxable.toFixed(2),
    trade_in_value: +num(d.trade_in_value).toFixed(2),
    taxable_net: +taxableNet.toFixed(2),
    tax_exempt: taxExempt,
    hst,
    non_taxable_fees: +nonTaxableFees.toFixed(2),
    licensing_fee: +num(d.licensing_fee).toFixed(2),
    total,
    deposit: +num(d.deposit).toFixed(2),
    balance_due: balance,
  };
}
